module.exports = __webpack_public_path__ + "img/home-selected.4d76bbfb.svg";